// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"df7f4219","337":"eb5223ee","683":"e97d7326","787":"abcb2e3a"}[chunkId] + ".chunk.js";
};